import { IsNotEmpty } from "class-validator";

import { DogDto } from "./dog.dto";

export class DogByClubManagerDto extends DogDto {
  @IsNotEmpty()
  owner_id: string;
}
